import { useState } from 'react';

import DownIcon from 'assets/icons/down.svg';
import { useDarkMode } from 'utils/hooks/DarkMode';
import DownWhiteIcon from 'assets/icons/down-white.svg';
import { VerticalAccordionProps } from 'interfaces/components/verticalAccordion';

const VerticalAccordion = ({
  title,
  content,
  titleClassName,
  contentClassName,
  defaultExpand = false,
  iconPosition = 'start',
  titleContainerClassName
}: VerticalAccordionProps) => {
  const [expanded, setExpanded] = useState(defaultExpand);
  const isDarkMode = useDarkMode('(prefers-color-scheme: dark)');

  const toggleExpanded = () => {
    setExpanded(prev => !prev);
  };

  return (
    <div className='flex flex-col items-center gap-2 w-full py-2 overflow-hidden'>
      <div
        onClick={toggleExpanded}
        className={`flex items-center gap-1 w-full cursor-pointer ${
          iconPosition === 'end'
            ? 'flex-row-reverse justify-end'
            : 'flex-row justify-start'
        } ${titleContainerClassName}`}
      >
        <img
          alt={expanded ? 'collapse' : 'expand'}
          src={isDarkMode ? DownWhiteIcon : DownIcon}
          className={`ease-in-out duration-300 ${expanded ? '' : '-rotate-90'}`}
        />

        <p
          className={`font-semibold text-base whitespace-nowrap select-none
            ${
              expanded
                ? 'text-black dark:text-white'
                : 'text-gray-700 dark:text-gray-400'
            } ${titleClassName || ''}`}
        >
          {title}
        </p>
      </div>

      <div
        className={`flex flex-col gap-1 w-full py-1 ease-in-out duration-300
                    ${
                      expanded
                        ? `max-h-96 ${contentClassName || ''}`
                        : 'max-h-0 opacity-0'
                    }`}
      >
        {content}
      </div>
    </div>
  );
};

export default VerticalAccordion;
